import React, { useEffect, useState } from "react";
import { endPoints } from "../../constant/Environment";
import { getAllData } from "../../Utility/API";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Button } from "react-bootstrap";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Loader from "../../components/Loader";

const statusColor = (status) => {
  if (status === "WON") return "#03B349";
  if (status === "LOST") return "#fa114f";
  return "#DB9F06";
};

const LotteryTicketsModal = ({ open, onClose, lottery }) => {
  const [tickets, setTickets] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (open && lottery?.id) {
      fetchTickets();
    }
  }, [open, lottery?.id]);

  const fetchTickets = () => {
    let url = `${endPoints.api.GET_LOTTERY_TICKETS}/${lottery.id}/tickets`;
    setIsLoading(true);
    getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setTickets(response.data || []);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  return (
    <Dialog maxWidth="md" fullWidth open={open} onClose={onClose}>
      <DialogTitle>Buyers - {lottery?.name}</DialogTitle>
      <DialogContent dividers>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <TableContainer component={Paper}>
          <Table size="small" className="c_table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Ticket ID</TableCell>
                <TableCell align="center">User ID</TableCell>
                <TableCell align="center">Numbers Picked</TableCell>
                <TableCell align="center">Purchased On</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center">Prize (SC)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tickets?.length ? (
                tickets.map((t) => (
                  <TableRow key={t.id}>
                    <TableCell align="center">{t.id}</TableCell>
                    <TableCell align="center">{t.idUser}</TableCell>
                    <TableCell align="center">
                      {t.numbers?.join(", ")}
                    </TableCell>
                    <TableCell align="center">
                      {t.createdAt
                        ? new Date(t.createdAt).toLocaleString()
                        : ""}
                    </TableCell>
                    <TableCell align="center">
                      <span
                        style={{
                          color: statusColor(t.status),
                          fontWeight: 700,
                        }}
                      >
                        {t.status}
                      </span>
                    </TableCell>
                    <TableCell align="center">{t.prizeSc || 0}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell align="center" colSpan={6}>
                    No tickets purchased yet.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LotteryTicketsModal;
